module.exports = __webpack_public_path__ + "assets/img/ic-openAccount.1f242b32.svg";